import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  Row,
  Col,
  Label,
  Input,
} from "reactstrap";
import { SketchPicker } from "react-color";
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import ColourPIcker from "./Components/ColourPIcker";


const Pie_Chart_Value_Edits = ({
  children,
  original_chart,
  sample_chart,
  setsample_chart,
}) => {
  const [colorRGBA, setcolorRGBA] = useState("rgba(247, 204, 83, 1)");

  const [display_RGBA, setdisplay_RGBA] = useState(false);
  const onSwatchHover_RGBA = () => {};

  function handleRGBA() {
    setdisplay_RGBA(!display_RGBA);
  }

  // range slider
  const [mincost, setMincost] = useState(0);
  const [maxcost, setMaxcost] = useState(2000);
  //slider function
  const onUpDate = (value) => {
    setMincost(value[0]);
    setMaxcost(value[1]);
  };

  useEffect(() => {
    onUpDate([mincost, maxcost]);
    console.log("Original Chart:", original_chart.data.datasets);
  }, [mincost, maxcost]);
  return (
    <>
      <Row className="mb-3">
        <Col lg="4" md="4">
          {children}
          <div>
            <Label className="form-check-label" htmlFor="">
              Slice Colors
            </Label>

            {original_chart.data.datasets[0].backgroundColor.map(
              (ele, index) => {
                return (
                  <div key={index}>
                    <ColourPIcker
                      original_chart={original_chart}
                      index={index}
                      default_color={ele}
                      setsample_chart={setsample_chart}
                    />
                  </div>
                );
              }
            )}
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Slice Border Color
          </Label>
          <div>
            <div className="nano-colorpicker" onClick={handleRGBA}>
              <i
                style={{
                  height: "28px",
                  width: "28px",
                  background: colorRGBA,
                  display: "block",
                }}
              />
            </div>

            {display_RGBA ? (
              <SketchPicker
                color="#fff"
                value={colorRGBA}
                width="160px"
                onChangeComplete={onSwatchHover_RGBA}
              />
            ) : null}
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="" htmlFor="">
            Slice Border Width
          </Label>
          <div id="nonlinear" data-slider-color="Secondary">
            <Nouislider
              range={{
                min: 0,
                max: 100,
              }}
              start={[50]}
              connect
              onSlide={onUpDate}
            />
          </div>
          <div className="d-flex justify-content-between">
            <div className="example-val" id="lower-value"></div>
          </div>
        </Col>
      </Row>
      {/* ========== */}

      <Row className="mb-3">
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Legend Visibility
          </Label>
          <div className="form-check mb-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="formCheck1"
            />
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Label Color
          </Label>
          <div>
            <div className="nano-colorpicker" onClick={handleRGBA}>
              <i
                style={{
                  height: "28px",
                  width: "28px",
                  background: colorRGBA,
                  display: "block",
                }}
              />
            </div>

            {display_RGBA ? (
              <SketchPicker
                color="#fff"
                value={colorRGBA}
                width="160px"
                onChangeComplete={onSwatchHover_RGBA}
              />
            ) : null}
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="" htmlFor="">
            Label Font Size
          </Label>
          <div id="nonlinear" data-slider-color="Secondary">
            <Nouislider
              range={{
                min: 0,
                max: 100,
              }}
              start={[50]}
              connect
              onSlide={onUpDate}
            />
          </div>
          <div className="d-flex justify-content-between">
            <div className="example-val" id="lower-value"></div>
          </div>
        </Col>
      </Row>
      {/* ========== */}

      <Row className="mb-3">
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Tooltip Toggle
          </Label>
          <div className="form-check mb-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="formCheck1"
            />
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Tooltip Background Color
          </Label>
          <div>
            <div className="nano-colorpicker" onClick={handleRGBA}>
              <i
                style={{
                  height: "28px",
                  width: "28px",
                  background: colorRGBA,
                  display: "block",
                }}
              />
            </div>

            {display_RGBA ? (
              <SketchPicker
                color="#fff"
                value={colorRGBA}
                width="160px"
                onChangeComplete={onSwatchHover_RGBA}
              />
            ) : null}
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="" htmlFor="">
            Tooltip Font Size
          </Label>
          <div id="nonlinear" data-slider-color="Secondary">
            <Nouislider
              range={{
                min: 0,
                max: 100,
              }}
              start={[50]}
              connect
              onSlide={onUpDate}
            />
          </div>
          <div className="d-flex justify-content-between">
            <div className="example-val" id="lower-value"></div>
          </div>
        </Col>
      </Row>
      {/* ========== */}

      <Row className="mb-3">
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Data Label Visibility
          </Label>
          <div className="form-check mb-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="formCheck1"
            />
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Data Label Color
          </Label>
          <div>
            <div className="nano-colorpicker" onClick={handleRGBA}>
              <i
                style={{
                  height: "28px",
                  width: "28px",
                  background: colorRGBA,
                  display: "block",
                }}
              />
            </div>

            {display_RGBA ? (
              <SketchPicker
                color="#fff"
                value={colorRGBA}
                width="160px"
                onChangeComplete={onSwatchHover_RGBA}
              />
            ) : null}
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="" htmlFor="">
            Data Label Font Size
          </Label>
          <div id="nonlinear" data-slider-color="Secondary">
            <Nouislider
              range={{
                min: 0,
                max: 100,
              }}
              start={[50]}
              connect
              onSlide={onUpDate}
            />
          </div>
          <div className="d-flex justify-content-between">
            <div className="example-val" id="lower-value"></div>
          </div>
        </Col>
      </Row>
      {/* ========== */}

      <Row className="mb-3">
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Percentage Display
          </Label>
          <div className="form-check mb-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="formCheck1"
              onChange={(check) => {
                if (check.target.checked) {
                  original_chart.config.options = {
                    ...original_chart.config.options,
                    plugins: {
                      legend: {
                        labels: {
                          // Show percentages in legend
                          generateLabels: (chart) => {
                            const data = chart.data;
                            if (data.labels.length && data.datasets.length) {
                              const dataset = data.datasets[0];
                              const total = dataset.data.reduce(
                                (acc, val) => acc + val,
                                0
                              );

                              return data.labels.map((label, i) => {
                                const value = dataset.data[i];
                                const percentage = (
                                  (value / total) *
                                  100
                                ).toFixed(1);

                                return {
                                  text: `${label}: ${percentage}%`,
                                  fillStyle: dataset.backgroundColor[i],
                                  hidden: false,
                                  index: i,
                                };
                              });
                            }
                            return [];
                          },
                        },
                      },
                      tooltip: {
                        callbacks: {
                          // Show percentages in tooltips
                          label: (context) => {
                            const label = context.label || "";
                            const value = context.parsed;
                            const total = context.dataset.data.reduce(
                              (acc, val) => acc + val,
                              0
                            );
                            const percentage = ((value / total) * 100).toFixed(
                              1
                            );
                            return `${label}: ${value} (${percentage}%)`;
                          },
                        },
                      },
                    },
                  };

                  original_chart.update()
                }else{
                  original_chart.config.options = {
                    ...original_chart.config.options,
                    plugins: {
                      legend: {
                        labels: {
                        
                        },
                      },
                      tooltip: {
                       
                      },
                    },
                  };
                }
                original_chart.update()
              }}
            />
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Chart Background Color
          </Label>
          <div>
            <div className="nano-colorpicker" onClick={handleRGBA}>
              <i
                style={{
                  height: "28px",
                  width: "28px",
                  background: colorRGBA,
                  display: "block",
                }}
              />
            </div>

            {display_RGBA ? (
              <SketchPicker
                color="#fff"
                value={colorRGBA}
                width="160px"
                onChangeComplete={onSwatchHover_RGBA}
              />
            ) : null}
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="" htmlFor="">
            Pie Border Width
          </Label>
          <div id="nonlinear" data-slider-color="Secondary">
            <Nouislider
              range={{
                min: 0,
                max: 100,
              }}
              start={[50]}
              connect
              onSlide={onUpDate}
            />
          </div>
          <div className="d-flex justify-content-between">
            <div className="example-val" id="lower-value"></div>
          </div>
        </Col>
      </Row>
      {/* ========== */}

      <Row className="mb-3">
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Hover Effect
          </Label>
          <div className="flex-shrink-0">
            <div className="form-check form-switch form-switch-right form-switch-md">
              <Input
                className="form-check-input code-switcher"
                type="checkbox"
              />
            </div>
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Donut Mode
          </Label>
          <div className="flex-shrink-0">
            <div className="form-check form-switch form-switch-right form-switch-md">
              <Input
                className="form-check-input code-switcher"
                type="checkbox"
              />
            </div>
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="" htmlFor="">
            Start Angle
          </Label>
          <div id="nonlinear" data-slider-color="Secondary">
            <Nouislider
              range={{
                min: 0,
                max: 100,
              }}
              start={[50]}
              connect
              onSlide={onUpDate}
            />
          </div>
          <div className="d-flex justify-content-between">
            <div className="example-val" id="lower-value"></div>
          </div>
        </Col>
      </Row>
      {/* ========== */}

      <Row className="mb-3">
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Responsive Mode
          </Label>
          <div className="flex-shrink-0">
            <div className="form-check form-switch form-switch-right form-switch-md">
              <Input
                className="form-check-input code-switcher"
                type="checkbox"
              />
            </div>
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Chart Animation
          </Label>
          <div className="flex-shrink-0">
            <div className="form-check form-switch form-switch-right form-switch-md">
              <Input
                className="form-check-input code-switcher"
                type="checkbox"
              />
            </div>
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="" htmlFor="">
            Cutout Percentage
          </Label>
          <div id="nonlinear" data-slider-color="Secondary">
            <Nouislider
              range={{
                min: 0,
                max: 100,
              }}
              start={[50]}
              connect
              onSlide={onUpDate}
            />
          </div>
          <div className="d-flex justify-content-between">
            <div className="example-val" id="lower-value"></div>
          </div>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Explode Slices
          </Label>
          <div className="flex-shrink-0">
            <div className="form-check form-switch form-switch-right form-switch-md">
              {/* <Label className="form-label text-muted">Line Dash </Label> */}
              <Input
                className="form-check-input code-switcher"
                type="checkbox"
              />
            </div>
          </div>
        </Col>
        <Col lg="4" md="4">
          <Label className="form-check-label" htmlFor="">
            Label Position
          </Label>
          <select
            className="form-select mb-3"
            aria-label="Default select example"
          >
            <option>Select your Status </option>
            <option value="1">Inside</option>
            <option value="2">Outside</option>
          </select>
        </Col>
        <Col lg="4" md="4">
          <Label className="" htmlFor="">
            Rotation Angle
          </Label>
          <div id="nonlinear" data-slider-color="Secondary">
            <Nouislider
              range={{
                min: 0,
                max: 100,
              }}
              start={[50]}
              connect
              onSlide={onUpDate}
            />
          </div>
          <div className="d-flex justify-content-between">
            <div className="example-val" id="lower-value"></div>
          </div>
        </Col>
      </Row>
      {/* ========== */}
    </>
  );
};

export default Pie_Chart_Value_Edits;
